import { CampaignDetailContextProvider } from "../../contexts/CampaignDetailContext"
import { CampaignContentRouter } from "../../routers/CampaignContentRouter"
import { SidebarRouter } from "../../routers/SidebarRouter"

import { CampaignLayoutMap } from "../CampaignLayoutMap"

import * as Styled from "./CampaignDesktopLayout.styled"

export const CampaignDesktopLayout = () => {
    return (
        <CampaignDetailContextProvider>
            <Styled.Wrapper>
                <SidebarRouter />
                <CampaignContentRouter />
                <CampaignLayoutMap />
            </Styled.Wrapper>
        </CampaignDetailContextProvider>
    )
}